/**
 * Vite entry point.
 * Mounts the React app into the #root div.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './global.css';
import './i18n/i18n';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
